import React from "react";

function Home() {
  return (
    <section id="home" style={{ textAlign: "center", marginTop: "60px" }}>

      <h1>Welcome to Modern Business</h1>
      <p>
        We provide high quality web solutions with modern frontend
        technologies.
      </p>
    </section>
  );
}

export default Home;
